<template>
  <div>
    <div class="table-operations">
      <h1>活动：{{event.name}}</h1>
      <span class="sub-text">活动日期：{{event.startTime+"~"+event.endTime}}</span>
    </div>
    <p></p>
    <div id="components-form-demo-advanced-search">
      <a-form layout="inline" class="ant-advanced-search-form">
        <a-row>
          <a-col :span="6">
            <a-form-item label="商品名称">
              <a-input size="small" v-model="queryParam.query_name_like" placeholder="商品名称" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="所属品牌">
              <a-select
                size="small"
                v-model="queryParam.query_brandId_eq"
                defaultValue
                width="200px"
              >
                <a-select-option value>----请选择----</a-select-option>
                <a-select-option
                  v-for="option in brandList"
                  v-bind:key="option.value"
                >{{ option.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="所属分类">
              <a-select
                size="small"
                v-model="queryParam.query_groupUid_eq"
                defaultValue
                style="width:200px"
              >
                <a-select-option value>----请选择----</a-select-option>
                <a-select-option
                  v-for="option in productGroup"
                  v-bind:key="option.value"
                >{{ option.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :span="6">
              <a-form-item label="商品状态">
                <a-select
                  size="small"
                  v-model="queryParam.query_state_eq"
                  defaultValue
                  style="width:200px"
                >
                  <a-select-option value>--请选择--</a-select-option>
                  <a-select-option
                    v-for="option in productStateList"
                    v-bind:key="option.value"
                  >{{ option.text }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="规格">
                <a-input
                  size="small"
                  v-model="queryParam.query_specification_like"
                  placeholder="规格"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden', } || {} "
            >
              <a-button size="small" type="primary" @click="reloadTable">查询</a-button>
              <a-button style="margin-left: 8px" size="small" @click="queryParamRest">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <p></p>
    <div class="table-operations"></div>
    <a-table
      ref="table"
      bordered
      :columns="columns"
      rowKey="id"
      :dataSource="data"
      :pagination="pagination"
      :pageSizeOptions="pagination.pageSizeOptions"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <div v-if="productInEvent(record.id)">
          <a-button size="small" @click="showModal(record)">修改活动价格</a-button>
          <a-divider type="vertical" />
          <a-button size="small" type="danger" @click="removeFromEvent(record)">从活动中移除</a-button>
        </div>
        <div v-else>
          <a-button size="small" @click="addToEvent(record)">加入活动</a-button>
        </div>
      </span>
      <span slot="eventPrice" slot-scope="text,record">{{getEventPrice(record)}}</span>
      <span slot="brandInfo" slot-scope="text">{{text | dictText(brandList)}}</span>
      <span slot="groupUid" slot-scope="text">{{text | dictText(productGroup)}}</span>

      <span slot="picture" slot-scope="text">
        <a-avatar
          v-if="text!=null && text!=''"
          shape="square"
          :size="120"
          v-bind:src="httpRoot+'/'+text"
        />
      </span>
    </a-table>

    <a-modal title="更新活动价格" v-model="visible" @ok="updateEventPrice()">
      {{this.currentProduct.name}}
      <a-form layout="inline">
        <a-form-item label="活动价格">
          <a-input-number
            width="100%"
            :min="0"
            :step="0.01"
            :precision="2"
            v-model="currentProduct.eventPrice"
            @change="inputFun"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: "eventAddProductIndex",
  mounted() {},
  created() {
    this.initEventProducts();
    this.$http.get("/api/1.0/event/get/" + this.$route.params.id).then(res => {
      this.event = res.data;
    });

    this.$http.get("api/1.0/brand/list").then(res => {
      this.brandList = res.data;
    });
    this.$http.get("/api/1.0/productGroup/list").then(res => {
      this.productGroup = res.data;
    });
    this.queryParamRest();
  },
  data() {
    return {
      currentProduct: {},
      visible: false,
      event: {},
      eventProductIds: [],
      productGroup: [],
      httpRoot: this.$defines.hostRoot,
      brandList: [],
      advanced: false,
      queryParam: {},
      data: [], //渲染表格数据
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `Total ${total} items`
      },
      loading: false,
      columns: [
        {
          title: "商品名称",
          dataIndex: "name",
          sorter: true
        },
        {
          title: "封面图片",
          dataIndex: "picture",
          scopedSlots: { customRender: "picture" }
        },
        {
          title: "普通售价",
          dataIndex: "price",
          align: "right",
          sorter: true
        },
        {
          title: "活动价",
          dataIndex: "eventPrice",
          align: "right",
          scopedSlots: { customRender: "eventPrice" }
        },
        {
          title: "所属分类",
          dataIndex: "groupUid",
          sorter: true,
          scopedSlots: { customRender: "groupUid" }
        },
        {
          title: "所属品牌",
          dataIndex: "brandId",
          sorter: true,
          scopedSlots: { customRender: "brandInfo" }
        },
        {
          title: "规格",
          dataIndex: "specification",
          sorter: true
        },

        {
          title: "操作",
          key: "action",

          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.fetch(
        this.$http.initParams(pagination, filters, sorter, this.queryParam)
      );
    },
    fetch(params = {}) {
      this.loading = true;
      this.$http.get("/api/1.0/product/page", params).then(res => {
        const data = res.data;
        this.data = data.records;
        const pagination = { ...this.pagination };
        pagination.total = data.total;
        pagination.pageSize = data.size;
        pagination.current = data.current;
        this.pagination = pagination;
      });
      this.loading = false;
    },
    onShowSizeChange: () => {
      this.pagination.pageSize = pageSize;
    },

    queryParamRest() {
      this.queryParam = {
        query_state_eq: "",
        query_brandId_eq: "",
        query_groupUid_eq: ""
      };
      this.reloadTable();
    },
    reloadTable() {
      this.handleTableChange(this.pagination, null, null, this.queryParam);
    },

    addToEvent(product) {
      const params = {
        eventId: this.event.id,
        productId: product.id,
        price: product.price,
        priceType: "EventPrice"
      };
      this.$http.post("/api/1.0/productPrice/save", params).then(res => {
        this.initEventProducts();
        this.reloadTable();
      });
    },
    updateEventPrice() {
      let eventPrice = {};
      this.eventProductIds.forEach(item => {
        if (item.productId == this.currentProduct.id) {
          eventPrice = item;
        }
      });

      eventPrice["price"] = this.currentProduct.eventPrice;

      this.$http.post("/api/1.0/productPrice/update", eventPrice).then(res => {
        this.initEventProducts();
        this.reloadTable();
      });
      this.visible = false;
      this.currentProduct = {};
    },
    inputFun(value) {
      this.currentProduct.eventPrice = value;
    },

    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    removeFromEvent(product) {
      let eventPrice = {};
      this.eventProductIds.forEach(item => {
        if (item.productId ==product.id) {
          eventPrice = item;
        }
      });
      this.$http.post("/api/1.0/productPrice/delete/"+eventPrice.id ).then(res => {
        this.initEventProducts();
        this.reloadTable();
      });
    },
    handleUploadFileChange(info, record) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        if (info.file.response.code == 200) {
          const fileName = info.file.response.data;

          this.$http
            .post("/api/1.0/product/update", {
              id: record.id,
              picture: fileName
            })
            .then(res => {
              if (res.code === 200) {
                record.picture = fileName;
                this.$message.success(`${record.name}的封面图片上传成功！`);
              } else {
                this.$message.error(`${record.name}的封面图片上传失败！`);
              }
            });
        } else {
          this.$message.error(`${record.name}的封面图片上传失败！`);
        }
      } else if (info.file.status === "error") {
        this.$message.error(`文件上传失败`);
      }
    },
    productInEvent: function(productId) {
      let isInEvent = false;
      if (null == this.eventProductIds) {
        isInEvent = false;
      }
      this.eventProductIds.forEach(item => {
        if (item.productId == productId) {
          isInEvent = true;
        }
      });
      return isInEvent;
    },
    getEventPrice: function(product) {
      let eventPrice = "";
      this.eventProductIds.forEach(item => {
        if (item.productId == product.id) {
          eventPrice = item.price;
          product["eventPrice"] = eventPrice;
        }
      });
      return eventPrice;
    },
    initEventProducts() {
      this.$http
        .get("/api/1.0/productPrice/list", {
          "query-eventId-eq": this.$route.params.id,
          "query-priceType-eq": "EventPrice"
        })
        .then(res => {
          this.eventProductIds = res.data;
        });
    },
    showModal: function(product) {
      this.currentProduct = product;
      this.visible = true;
    }
  },
  filters: {}
};
</script>

<style scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>